module.exports = __webpack_public_path__ + "img/office.77e385de.png";